/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { shallowEqual, useDispatch, useIntl, useSelector } from 'umi';
import {
  Modal,
  Button,
  Form,
  Input,
  Checkbox,
  notification,
  Radio,
} from 'tea-component';
import { useLocal } from '@/pages/dashboard/utils/customHook';
import {
  addSelectorSchemeList,
  editSelectorSchemeList,
} from '@/pages/dashboard/services/dashboardSetting';
import {
  CONTRAST_DAITE,
  DATE_FILTER_ARR,
  DATE_TIME_RANGE,
  RANGE_DATE,
  RANGE_DAY_MONTH,
  RANGE_TIME,
  TIMETYPE_OBJ,
} from '../FilterBase/_config';
import inputMap from '../FilterBase/FilterList';
import { getDefaultValueFromSaved, getRangeDataKey, isNewCascadeFilter } from '../util';
import TipContext from '@/pages/home/components/TipContext';
import { getDateVal } from '@/pages/dashboard/utils/utils';
import { RANGE_DATE_KEY, LATEST_DATE_KEY_ARR } from '../_config';
import { debounce } from 'lodash-es';

import '@/pages/dashboard/assets/scss/components/saveFilterSetting.scss';
import renderCustom from '../FilterBase/RenderCustomSelect';
import { getCustomFilterList } from '../customFilterList';

export default function SaveFilterSetting(props: any) {
  const {
    visible,
    close,
    gameCode,
    formValue: defaultValue,
    isOutScheme,
    getOutSelectorSchemeList,
    selectorSchemeList,
    inputList,
    type,
    editFilter,
    selector,
    path,
    alignedType,
  } = props;

  const dispatch = useDispatch();
  const { selectedfilterDuration, gameConfig, filterDurationData }: any = useSelector((state: any) => {
    const { gameConfig, selectedfilterDuration, filterDurationData } = state?.dashboardSetting;
    return {
      gameConfig,
      selectedfilterDuration,
      filterDurationData
    };
  }, shallowEqual);
  const selectedfilterDurationRef = useRef(selectedfilterDuration);
  const renderInputList = inputList?.filter((v: any) => v?.visible !== 0) || [];
  const renderInputListKeyArr = renderInputList?.map((v: any) => v?.key) || [];
  const editFilterObj = editFilter?.filter_cond || {};
  const [errorMessage, setErrorMessage] = useState(''); // 错误校验信息
  const [filterName, setFilterName] = useState('');
  const { locale, getLocalText, isEN } = useLocal('filter');
  const [formValue, setFormValue] = useState(defaultValue);
  const isDefaultInit = type === 'edit' ? editFilterObj?.is_default : false;
  const [isDefault, setIsDefault] = useState(isDefaultInit);
  const filterSaveDateTypeInit = type === 'edit' ? (editFilterObj?.ext_filter?.dateSaveType || 'dateSelect') : 'dateDuration';
  const [filterSaveDateType, setFilterSaveDateType] = useState(filterSaveDateTypeInit);
  const { formatMessage } = useIntl();
  const [timeTypeVal, setTimeTypeVal] = useState<string>('');
  const getDateDurationText = () => {
    let resultText = '';
    if (type === 'edit' && editFilterObj?.ext_filter?.dateSaveType === 'dateDuration') {
      const dateSaveValType = editFilterObj?.ext_filter?.dateSaveVal;
      const editItem = filterDurationData?.[dateSaveValType];
      const isLatestDate = LATEST_DATE_KEY_ARR?.includes(dateSaveValType);
      resultText = isLatestDate ? dateDurationTextObj?.[selectedfilterDuration.type] : editItem?.[isEN ? 'name' : 'nameCN'];
    }
    return resultText;
  };
  const [dateDurationText, setDateDurationText] = useState<string>(getDateDurationText());
  const isDisabled = useMemo(() => {
    // const selectedShow = renderInputListKeyArr?.filter((item: any) => selectedFilter?.includes(item)) || [];
    const selectedShow = renderInputListKeyArr || [];
    return selectedShow?.length === 0;
  }, [renderInputList]); // selectedFilter

  const filterList = useMemo(() => {
    return selectorSchemeList?.map(
      (item: { filter_name: any; }) => item?.filter_name || '',
    );
  }, [selectorSchemeList]);

  const { otherFilterArr, dateFilterArr, firstDateTimeType, saveDurationType, firstDateKey } = useMemo(() => {
    const dateFilterArr =
      renderInputList?.filter((item: { type: string; key: string; }) => {
        const key = item?.type || item?.key;
        return DATE_FILTER_ARR?.includes(key);
      }) || [];

    const otherFilterArr =
      renderInputList?.filter((item: { type: string; key: string; }) => {
        const key = item?.type || item?.key;
        return !DATE_FILTER_ARR?.includes(key);
      }) || [];

    const firtstDateFilter = dateFilterArr?.[0];
    const firstDateKey = firtstDateFilter?.type || firtstDateFilter?.key;
    const isDateRangeFilter = DATE_TIME_RANGE?.includes(firstDateKey);
    const firstDateTimeType = isDateRangeFilter ? formValue?.[RANGE_TIME]?.type : (TIMETYPE_OBJ?.[firstDateKey] || firstDateKey);
    const saveDurationType = isDateRangeFilter ? firstDateTimeType : firstDateKey;

    return {
      dateFilterArr: dateFilterArr,
      firstDateKey: firstDateKey,
      otherFilterArr: otherFilterArr,
      firstDateTimeType: firstDateTimeType,
      saveDurationType: saveDurationType
    };
  }, [renderInputList, formValue]);

  useEffect(() => {
    if (firstDateKey === RANGE_DAY_MONTH) {
      setFilterSaveDateType('dateSelect');
    }
  }, [firstDateKey]);

  const dateDurationTextObj: { [key: string]: string; } = useMemo(() => {
    return {
      date: getLocalText('save_last_day'),
      week: getLocalText('save_last_week'),
      month: getLocalText('save_last_month'),
      lasteDateDate: getLocalText('save_last_day'),
      lasteDateWeek: getLocalText('save_last_week'),
      lasteDateMonth: getLocalText('save_last_month'),
      singleDaily: getLocalText('save_last_single_day'),
    };
  }, [locale]);

  useEffect(() => {
    // 编辑方案时，如果没有选择快捷时间，则用方案中默认的duration
    if (type === 'edit' && selectedfilterDurationRef?.current?.type === selectedfilterDuration?.type && filterSaveDateTypeInit === 'dateDuration') {
      return;
    }
    let resultText = '';
    if (LATEST_DATE_KEY_ARR?.includes(selectedfilterDuration.type)) {
      resultText = dateDurationTextObj?.[selectedfilterDuration.type];
    } else {
      resultText = selectedfilterDuration ? selectedfilterDuration?.[isEN ? 'name' : 'nameCN'] : dateDurationTextObj?.[firstDateTimeType];
    }
    setDateDurationText(resultText);
  }, [locale, selectedfilterDuration, firstDateTimeType]);

  useEffect(() => {
    if (
      !selectedfilterDuration?.type ||
      LATEST_DATE_KEY_ARR?.includes(selectedfilterDuration?.type)
    ) {
      // 和产品沟通后，当选择latestData时，展示昨天、上周、上月
      // 没有选择duration或者duration为latestDate，则按照筛选器key存储
      setTimeTypeVal(saveDurationType);
    } else {
      setTimeTypeVal(selectedfilterDuration?.type);
    }
  }, [selectedfilterDuration?.type, saveDurationType]);

  // 编辑弹窗默认赋值逻辑
  useEffect(() => {
    if (type === 'edit') {
      const { filter_name, filter_cond } = editFilter || {};
      const newFormValue = getDefaultValueFromSaved(
        inputList,
        filter_cond,
        formValue,
        selector,
        filterDurationData,
      );
      setErrorFunc(filter_name);
      setFilterName(filter_name || '');
      setFormValue(newFormValue);
      setIsDefault(filter_cond?.is_default);
    }
  }, [type]);

  const setErrorFunc = (val: string) => {
    const isError = filterList?.includes(val?.trim());
    const isNull = val?.trim() === '';
    if (isNull) {
      setErrorMessage(formatMessage({ id: 'filter_save_enter_a_name' }));
      return;
    }
    setErrorMessage(
      isError
        ? type === 'edit'
          ? formatMessage({ id: 'filter_edit_error_message' })
          : formatMessage({ id: 'filter_save_error_message' })
        : '',
    );
  };

  const handleNameOnChange = (val: string) => {
    setFilterName(val);
    setErrorFunc(val);
  };

  const getTimeFilterVal = () => {
    const dateFilterArr = inputList?.filter((item: { type: any; key: any; }) => {
      const key = item.type || item.key;
      return DATE_FILTER_ARR?.includes(key);
    });
    const resultDateArr = dateFilterArr?.reduce((acc: { [x: string]: any; }, item: { type: any; key: any; }) => {
      const key = item.type || item.key;
      if (key === RANGE_DATE) {
        const { type, value: val } = formValue?.rangeTime;
        const savedKey: string = getRangeDataKey(type);
        if (savedKey) {
          acc[savedKey] = val || [];
        }
      } else if (key === RANGE_DAY_MONTH) {
        acc[key] = formValue?.[key] || [];
      } else {
        // 日、周、月等三个范围删选器是rangeTime，实时相关对比日是key
        acc[key] = formValue?.rangeTime || formValue?.[key] || [];
      }
      return acc;
    }, {});
    return resultDateArr;
  };


  const handleOnSubmit = () => {
    setErrorFunc(filterName);
    const isNull = filterName?.trim() === '';
    if (isNull || (errorMessage && type === 'add')) {
      return;
    }
    // eslint-disable-next-line prefer-const
    let filters: any = {};
    Object.keys(formValue)?.forEach((item: any) => {
      const visbleFlag = renderInputListKeyArr.includes(item);
      // 过滤掉筛选器中配置不展示的值
      if (visbleFlag) {
        filters[item] = formValue[item];
      }
    });
    const dateFilterArr = { ...(getTimeFilterVal() || []) };

    // 存储的时间类型是第一个时间筛选器的类型
    const firstkey = Object.keys(dateFilterArr)?.[0];

    let timeType = 'Day';
    if (firstkey === RANGE_DAY_MONTH) {
      timeType = formValue?.[RANGE_DAY_MONTH]?.type;
    } else if (RANGE_DATE_KEY?.[firstkey]) {
      timeType = RANGE_DATE_KEY?.[firstkey];
    } else {
      timeType = formValue?.rangeTime?.type;;
    }
    // 自定义筛选器赋值
    const customFilters = getCustomFilterList();
    const customFiltersObj: { [key: string]: any[] } = {};
    // 确保 customFilters 是数组
    const validCustomFilters = Array.isArray(customFilters) ? customFilters : [];
    validCustomFilters.forEach(item => {
      const filterValue = filters?.[item];
      // 查找对应的 inputList 配置，判断是否是级联筛选器
      const filterConfig = inputList?.find((inputItem: any) => {
        const key = inputItem?.type || inputItem?.key;
        return key === item;
      });
      // 判断是否是新级联筛选器（排除 region 和 category）
      const isCascade = filterConfig && isNewCascadeFilter(filterConfig, item);
      
      // 处理新的级联筛选器：如果是对象格式，提取子值（数组）
      // 级联筛选器值格式：{ parent: [...], [key]: [...], type: parentKey | childKey }
      // childKey 就是筛选器的 key，直接使用 key 作为 childKey
      if (isCascade && filterValue && typeof filterValue === 'object' && !Array.isArray(filterValue) && filterValue.type) {
        const childValues = filterValue[item] || [];
        // 确保子值是数组格式，防止类型错误
        customFiltersObj[item] = Array.isArray(childValues) ? childValues : [];
      } else {
        // 普通自定义筛选器，直接使用原值，确保是数组格式
        customFiltersObj[item] = Array.isArray(filterValue) ? filterValue : (filterValue ? [filterValue] : []);
      }
    });

    // 定制化筛选器参数
    const ext_filter: any = {
      app_version: filters?.appVersion || [],
      network_type: filters?.networkType || [],
      memory: filters?.memory || [],
      store_channel: filters?.storeChannel || [],
      stage: filters?.stage || [],
      churn_level: filters?.churn_level || [],
      metrics: filters?.metrics || [],
      bundle: filters?.bundle || [],
      competitor: filters?.competitor || [],
      source: filters?.source ? [filters?.source] : [],
      product: filters?.category?.product || [],
      category: filters?.category?.category || [],
      dateSaveType: filterSaveDateType,
      ...(filterSaveDateType === 'dateDuration'
        ? { dateSaveVal: timeTypeVal }
        : {}),
      ...(dateFilterArr || []),
      timeType: timeType || 'Day',
      ...(alignedType && {alignedType: alignedType }),
      ...(customFiltersObj || {})
    };

    const params: any = {
      game_code: gameCode,
      filter_name: filterName,
      filter_cond: {
        is_default: isDefault,
        filter_type: 'dashboard',
        zone: filters?.zone || [],
        channel: filters?.channel || [],
        region: filters?.region?.markets || [],
        system: filters?.system || [],
        lang: filters?.lang || [],
        ext_filter,
      },
    };
    if (isOutScheme) {
      params['page_path'] = path;
      params.filter_cond.filter_type = 'funnel';
    }

    if (type === 'edit') {
      const id = filterList?.includes(filterName)
        ? selectorSchemeList?.find(
          (item: any) => item?.filter_name === filterName,
        )?.id
        : editFilter?.id;
      editSelectorSchemeList({ id, ...params })
        .then((res) => {
          const isHaveSameName = filterList?.includes(filterName?.trim());
          notification.success({
            description: isHaveSameName
              ? getLocalText('edit_same_name_success', { name: filterName })
              : getLocalText('edit_success'),
            className: isHaveSameName
              ? 'filter-lock-alert-same-name'
              : 'filter-lock-alert',
            duration: 1000,
          });
          eventEnd(id);
        })
        .catch((err) => {
          notification.error({
            description: getLocalText('edit_fail'),
            className: 'filter-lock-alert',
            duration: 1000,
          });
        });
      return;
    }
    addSelectorSchemeList(params)
      .then((res) => {
        notification.success({
          description: getLocalText('save_save_success'),
          className: 'filter-lock-alert',
          duration: 1000,
        });
        eventEnd();
      })
      .catch((err) => {
        notification.error({
          description: getLocalText('save_save_fail'),
          className: 'filter-lock-alert',
          duration: 1000,
        });
      });
  };

  const eventEnd = (id?: string) => {
    // 请求游戏筛选器方案下拉框
    if (isOutScheme) {
      // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
      getOutSelectorSchemeList && getOutSelectorSchemeList();
    } else {
      dispatch({
        type: 'dashboardSetting/getSelectorSchemeList',
        payload: {
          gameCode,
        },
      });
    }
    close();
  };

  const onFilterChange = (key: string, value: any) => {
    const newValue = {
      ...formValue,
      [key]: value,
    };

    const isDateRangeFilter = DATE_TIME_RANGE?.includes(key);
    setFormValue(newValue);
    if (isDateRangeFilter) {
      setTimeTypeVal(value?.type);
    }
  };

  const isFunnel = useMemo(() => {
    return path?.includes('registerFunnel') && path?.includes('funnel');
  }, [path]);

  // 浮窗起止时间范围
  const bubbleRangeValue = useMemo(() => {
    const isRangeDayMonth = firstDateKey === RANGE_DAY_MONTH;
    if (isRangeDayMonth) {
      const prefix = formValue?.[RANGE_DAY_MONTH]?.type === 'Day' ? 'D' : 'M';
      const start = formValue?.[RANGE_DAY_MONTH]?.value?.[0];
      const end = formValue?.[RANGE_DAY_MONTH]?.value?.[1];
      return [`${prefix}${start}`, `${prefix}${end}`];

    } else {
      const start = getDateVal(formValue?.rangeTime?.[0]) || getDateVal(formValue?.rangeTime?.value?.[0]) || getDateVal(formValue?.singleDaily);
      const end = getDateVal(formValue?.rangeTime?.[1]) || getDateVal(formValue?.rangeTime?.value?.[1]) || getDateVal(formValue?.singleDaily);
      return [start, end];
    }
  }, [firstDateKey, formValue]);

  return (
    <Modal
      visible={visible}
      size={800}
      className="save-filter-setting"
      destroyOnClose
      caption={
        type === 'edit'
          ? getLocalText('edit_setting')
          : getLocalText('save_setting')
      }
      onClose={close}
    >
      <Modal.Body>
        {type === 'add' && !isFunnel && (
          <div className="setting-desc">{getLocalText('save_can_be_use')}</div>
        )}
        
        <Form className="setting-table">
          <Form.Item
            label={<div className='dbd-modal-form-lable'>{getLocalText('save_setting_name')}</div>}
            showStatusIcon={false}
            status={
              errorMessage
                ? type === 'edit' && filterList?.includes(filterName?.trim())
                  ? 'validating'
                  : 'error'
                : 'sucuss'
            }
            message={errorMessage}
          >
            <Input
              placeholder={getLocalText('save_enter_a_name')}
              size="full"
              value={filterName}
              onChange={handleNameOnChange}
            />
          </Form.Item>
          <Form.Item showStatusIcon={false}>
            <Checkbox
              value={isDefault}
              onChange={(value) => setIsDefault(value)}
            >
              <div className="dbd-neutral-text">
                {isFunnel
                  ? getLocalText('default_setting_funnel')
                  : getLocalText('default_setting')}
              </div>
            </Checkbox>
          </Form.Item>
          {
            dateFilterArr?.length > 0 &&    <Form.Item
              label={
                <div className='dbd-filter-lable'>
                  {getLocalText('save_time_setting')}
                  <TipContext
                    tipText={
                      <>
                        <p>{getLocalText('save_setting_title')}</p>
                        <p>{getLocalText('save_setting_info_start_end', {
                          start: bubbleRangeValue?.[0],
                          end: bubbleRangeValue?.[1]
                        })}</p>
                        {
                          firstDateKey !== RANGE_DAY_MONTH && <p>
                            {getLocalText('save_setting_info_duration', {
                              latestValue: dateDurationText || ''
                            })}
                          </p>
                        }
 
                      </>
                    }
                  />
                </div>
              }
              showStatusIcon={false}
            >
              <Radio.Group
                value={filterSaveDateType}
                onChange={(value) => setFilterSaveDateType(value)}
                className="dbd-filter-time"
              >
                <div className="dbd-filter-time-item">
                  <Radio name="dateSelect">
                    {dateFilterArr?.map((item: any, index: number) => {
                      const {
                        type,
                        key,
                        render: itemRender,
                        visible,
                        ...rest
                      } = item;
                      const isDateComparisonFilter = path === 'comparisonAnalysis/dateComparison';
                      const inputVal = formValue[key] || null;
                      const inputDefaultVal = defaultValue[key] || null;
                      const inputType = type || key;
                      const render = itemRender || inputMap[inputType];
                      // 时间对比页面日期保存的时候，不保存对比日期，弹窗内也不展示对比日期
                      const isContrastDateRange = inputType === CONTRAST_DAITE;
                      const renderFlag = !render || visible === 0;


                      // 后端接口返回（visible === 0）不展示
                      if (renderFlag || isContrastDateRange) return null;
                      // 维度筛选器
                      return (
                        <div
                          key={inputType + index}
                          className={`setting-group-date-item ${isDateComparisonFilter ? 'setting-group-date-comparision-item' : ''}`}
                        >
                          <div className="setting-flex">
                            <span className="dbd-filter-save-bubble-content">
                              {render({
                                ...rest,
                                key,
                                locale,
                                overlayClassName: 'dbd-range-picker-overly',
                                getLocalText,
                                latestDate: '',
                                value: inputVal,
                                defaultValue: inputDefaultVal,
                                onChange: onFilterChange,
                                // disabled: isRangeDateMonth,
                                dispatch: dispatch,
                                seasonInfo: gameConfig?.season_info,
                                renderKey: `save_select_${key}`,
                                // timeTabDisabled: isDateFilter
                              })}
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </Radio>
                </div>
                {
                  firstDateKey !== RANGE_DAY_MONTH && <div className="setting-group-item">
                    <Radio name="dateDuration">
                      <div className='dbd-neutral-lable'>{getLocalText('save_latest_date')}</div> {dateDurationText || ''}
                    </Radio>
                  </div>
                }
 
              </Radio.Group>
            </Form.Item>
          }
         
          {
            otherFilterArr?.length > 0 && <Form.Item
              label={<div className='dbd-filter-location'>{getLocalText('save_other_setting')}</div>}
              showStatusIcon={false}
            >
              <div className="setting-group mod-filter">
                {otherFilterArr?.map((item: any, index: number) => {
                  const {
                    type,
                    key,
                    render: itemRender,
                    visible,
                    name_en,
                    name_cn,
                    all_info_en,
                    all_info_cn,
                    // 直接使用 item 上已有的映射字段
                    lftName,
                    rtName,
                    parentChildName,
                    parentKey,
                    childKey,
                    radioOptions,
                    allInfo,
                    ...rest
                  } = item;
                    // 时间筛选器暂不做保存
                  const isDateFilter = DATE_FILTER_ARR?.includes(key);
                  const inputVal = formValue[key] || null;
       
                  const inputDefaultVal = defaultValue[key] || null;
                  const inputType = type || key;
                  const render = itemRender || inputMap[inputType] || renderCustom;
                  const renderFlag = !render || visible === 0;
                  const name = isEN ? name_en : name_cn;

                  // 后端接口返回（visible === 0）不展示
                  if (renderFlag) return null;
                  // 维度筛选器
                  return (
                    <>
                      <div className="setting-group-item" key={inputType + index}>
                        {render({
                          ...rest,
                          key,
                          locale,
                          getLocalText,
                          latestDate: '',
                          value: inputVal,
                          defaultValue: inputDefaultVal,
                          onChange: onFilterChange,
                          disabled: isDateFilter,
                          timeTabDisabled: isDateFilter,
                          name,
                          allInfo: allInfo || (isEN ? all_info_en : all_info_cn),
                          // 直接使用 item 上已有的映射字段
                          lftName,
                          rtName,
                          parentChildName,
                          parentKey,
                          childKey,
                          radioOptions,
                          renderKey: `save_select_${key}`,
                        })}
                      </div>
                    </>
                  );
                })}
              </div>

            </Form.Item>
          }
        </Form>

      </Modal.Body>
      <Modal.Footer>
        <Button type="primary" onClick={debounce(handleOnSubmit, 300)} disabled={isDisabled}>
          {formatMessage({ id: 'common_confirm' })}
        </Button>
        <Button type="weak" onClick={close}>
          {formatMessage({ id: 'common_cancel' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}


